const theme = {
  colors: {
    primary: '#6200ee',
    background: '#00000014',
    text: '#000000B3',
    success: '#135E01',
  },
  fonts: {
    fontFamily: 'Roboto, sans-serif',
  },
};

export default theme;
